import React, { useEffect, useState } from 'react';

import { useIntl } from 'react-intl';

import styled from 'styled-components/macro';
import { useAppContext, useComposition, useOrder, usePrice, useWorkspace, useAuth } from '../../context';
import { Title } from './drawer-content/styled';
import { uiColors } from '../../common/styles';



const SectionWrapper = styled.section`
    // padding: 6px 12px;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: center;
    pointer-events: none;
    z-index: 2;

    @media (max-width: 450px) {
        top: 6px;
        left: 6px;
        padding: 3px 6px;

    }
`;

const Price = styled.span`
    font-size: 18px;
    font-weight: 500;
    color: ${uiColors.PRIMARY_500};

    @media (max-width: 450px) {
        font-size: 18px;
    }
`
const PriceWithoutDiscount = styled.span`
    font-size: 12px;
    // font-weight: 500;
    color: ${uiColors.GRAY_400};
    // text-align: end;
    // line-height: 15.6px;
    // letter-spacing: 0.46px;
    text-decoration-line: line-through;
`;

const PriceWrapper = styled.div`
    display: flex;
    flex-direction: column;
    // padding-top: 5px;
    // padding-bottom: 5px;
`;

const PriceAdditionalDescription = styled.span`
    white-space: nowrap;
    font-size: 12px;
    font-weight: 500;
    color: ${uiColors.GREEN_800};
    text-align: left;

    @media (max-width: 450px) {
        font-size: 8px;
    }
`;


export const FooterPrice = () => {
    const { user } = useAuth();
    const { formatPrice } = usePrice();
    const { currentComp, activeFrame } = useComposition();
    const { order, getShippingCost } = useOrder();
    const [isDiscounted, setIsDiscounted] = useState(false);
    const [priceWithoutDiscount, setPriceWithoutDiscount] = useState();
    const [priceWithDiscount, setPriceWithDiscount] = useState();
    const [freeShippingThreshold, setFreeShippingThreshold] = useState(null);
    const { isEditMode } = useWorkspace();
    const { isMobile } = useAppContext();

    const intl = useIntl();

    useEffect(() => {
        if (order) {
            setFreeShippingThreshold(order.delivery?.free_shipping_threshold);
        } else if (currentComp) {
            const deliveryCost = getShippingCost(user?.country);
            setFreeShippingThreshold(deliveryCost?.free_shipping_threshold);
        }
    }, [currentComp?.id, user, order]);

    useEffect(() => {
        if (currentComp && currentComp.price && !isNaN(currentComp.price?.rounded.total_before_auto_discount)) {
            const totalPrice = currentComp.price?.rounded.total_before_auto_discount;
            const discountedPrice = currentComp.price?.rounded.discounted;
            setIsDiscounted(discountedPrice !== totalPrice);
            setPriceWithoutDiscount(totalPrice);
            setPriceWithDiscount(discountedPrice);
        }
    }, [currentComp?.price]);


    return (
        <SectionWrapper>
            {!isDiscounted ? (
                <Price>
                    {formatPrice(priceWithoutDiscount ?? 0)}
                </Price>
            ) : (
                <PriceWrapper>
                    <Price>
                        {formatPrice(priceWithDiscount ?? 0)}
                    </Price>
                    <PriceWithoutDiscount className="floatingBottomPriceWithoutDiscount">
                        {formatPrice(priceWithoutDiscount ?? 0)}
                    </PriceWithoutDiscount>
                </PriceWrapper>
            )}
            {/*<PriceAdditionalDescriptionPrimary>*/}
            {/*    {intl.formatMessage({ id: 'studio.bottomBar.hangingKit' })}*/}
            {/*    <GreenChip>Gratis</GreenChip>*/}
            {/*</PriceAdditionalDescriptionPrimary>*/}
            {!currentComp?.is_voucher && freeShippingThreshold <= Math.round(
                priceWithDiscount ?? 0) && !isEditMode && (
                    <PriceAdditionalDescription>
                        {intl.formatMessage({ id: 'studio.bottomBar.freeDelivery' })}
                    </PriceAdditionalDescription>
                )}
        </SectionWrapper>
    )
}
